import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Button } from '@components/button';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useToaster } from '@components/toaster';

import { api } from 'api';

import { Modal, ModalProps } from 'features/modals';
import { useStore } from 'models/Provider';

type Props = ModalProps<{
  departmentId: number;
  departmentTitle: string;
  userId: number;
  userName: string;
}>;

export const DeleteDepartmentUserModal = (props: Props) => {
  const { t, userStore } = useStore();
  const { departmentId, userId, closeModal, departmentTitle, userName } = props;
  const { showSuccess } = useToaster();

  const queryClient = useQueryClient();
  const submit = useMutation(() => api.departments.removeUser(departmentId, userId), {
    onSuccess: () => {
      queryClient.invalidateQueries(['departments']);
      userStore.load(true); // To load the user's updated departments
      showSuccess(t('modals.deletedepartmentuser.success'));
      closeModal();
    },
  });

  return (
    <Modal>
      <Text text={t('modals.deletedepartmentuser.header')} />
      <Stack space={4}>
        <Text
          text={
            <>
              {t('modals.deletedepartmentuser.areyousure.1')} <strong>{userName}</strong>{' '}
              {t('modals.deletedepartmentuser.areyousure.2')} <strong>${departmentTitle}</strong>
            </>
          }
        />
        <Text text={t('modals.deletedepartmentuser.fullaccessdescription')} />
      </Stack>
      <Modal.Actions>
        <Button
          variant="secondary"
          onClick={closeModal}
          text={t('modals.deletedepartmentuser.cancel')}
        />
        <Button
          isDisabled={submit.isLoading}
          variant="primary-red"
          onClick={() => submit.mutate()}
          text={t('modals.deletedepartmentuser.save')}
        />
      </Modal.Actions>
    </Modal>
  );
};
